export class OptionIcons {

    constructor(private iconName: string, private iconTooltip: string, public iconFunction: any) {
    }

    public getIconName() {
        return this.iconName;
    }

    public getIconTooltip() {
        return this.iconTooltip;
    }
}